import apiService from './api'
import { useMemorialStore } from '../stores/memorial'
import router from '../router'

/**
 * Centralized authentication service
 * Provides global auth functions to maintain consistency across the application
 */
export const authService = {
  /**
   * Login the user with email and password
   * Sets token in API service and memorial store
   * Returns the response from the API
   */
  async login(email, password) {
    try {
      const response = await apiService.signIn(email, password)

      if (response.success && response.token) {
        // Get the memorial store
        const store = useMemorialStore()

        // Store authentication data in both API service and memorial store
        apiService.setToken(response.token)
        store.setApiAuth(response.token, response.user)

        return { success: true, response }
      } else {
        return { success: false, error: response.msg || 'Login failed' }
      }
    } catch (error) {
      console.error('Login error:', error)
      return { success: false, error: error.message || 'Login failed' }
    }
  },

  /**
   * Logout the current user
   * Clears all authentication tokens, localStorage, and in-memory data
   * Redirects to login page
   */
  logout() {
    // Start server-side revocation before clearing the local token. keepalive on
    // the request allows it to finish while the UI navigates to the login page.
    if (apiService.getToken()) {
      apiService.signOut().catch(error => {
        console.warn('Could not revoke the current session on the server:', error)
      })
    }

    // Clear API token
    apiService.clearToken()

    // Clear memorial store data (if initialized)
    try {
      const store = useMemorialStore()
      store.clearAllData()
    } catch (error) {
      // Store might not be initialized in some contexts
      console.warn('Could not clear store data:', error)
    }

    // Clear all localStorage to ensure complete logout
    localStorage.clear()

    // Clear sessionStorage as well
    sessionStorage.clear()

    // Redirect to login page
    router.push('/login')
  }
}

export default authService
